<template>
  <div
    class="Reel"
    v-bind:class="{ 'is-locked': locked }"
    v-on:mousedown="lock()"
  >
    <div class="Reel-inner" v-if="reelTileData">
      <img
        class="Reel-image"
        :src="reelTileData[tile1Index].slotMachineRewardUrl"
      />
      <img
        class="Reel-image"
        :src="reelTileData[tile2Index].slotMachineRewardUrl"
      />
      <img
        class="Reel-image"
        :src="reelTileData[tile3Index].slotMachineRewardUrl"
      />
      <img
        class="Reel-image"
        :src="reelTileData[tile4Index].slotMachineRewardUrl"
      />
      <img
        class="Reel-image"
        :src="reelTileData[tile5Index].slotMachineRewardUrl"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["value", "canlock"],
  data: function () {
    return {
      momentum: null,
      audio: {
        bar: new Audio("https://freesound.org/data/previews/0/707_207-lq.mp3"),
        barWin: new Audio(
          "https://freesound.org/data/previews/337/337049_3232293-lq.mp3"
        ),
        spin: new Audio(
          "https://freesound.org/data/previews/120/120373_824230-lq.mp3"
        ),
        spinEnd: new Audio(
          "https://freesound.org/data/previews/145/145441_2615119-lq.mp3"
        ),
        lock: new Audio(
          "https://freesound.org/data/previews/56/56246_91374-lq.mp3"
        ),
      },
      reelTileData: null,
      reelIndex: 2,
      tile1Index: 0,
      tile2Index: 1,
      tile3Index: 2,
      tile4Index: 3,
      tile5Index: 4,
      locked: false,
      frs: [],
      counter: 0,
    };
  },
  beforeMount: function () {
    // Build up the reelTileData array with random tiles
    this.audio.spin.volume = 0.3;
    this.audio.spinEnd.volume = 0.8;
    this.audio.lock.volume = 0.2;
    this.audio.spin.currentTime = 0.3;
    // Method 1, random until count is reached
    // while (count > 0) {
    //   const fruitIndex = Math.floor(Math.random() * this.reelSourceData.length)
    //   const fruitObject = this.reelSourceData[fruitIndex]
    //   frs.push(fruitObject)
    //   count--
    // }

    // Method 2, sort on value, use index to determine entry count, shuffle
    this.sorting();
    this.reelTileData = this.shuffle(this.frs);
  },
  mounted: function () {
    this.$el.addEventListener("transitionend", this.animateEnd);
  },
  computed: {
    ...mapState(["customerReady"]),
    reelSourceData() {
      return this.$store.state.reelSourceData;
    },
  },
  watch: {
    customerReady: function (val) {
      if (val) this.init();
    },
  },
  methods: {
    init() {
      this.sorting();
      this.reelTileData = this.shuffle(this.frs);
    },
    sorting() {
      this.frs = [];
      let reelSourceData = this.reelSourceData.slice(0);
      reelSourceData.sort((a, b) => b.value - a.value);
      reelSourceData.forEach((sd, i) => {
        let times = i + 1 + i; // 0+1+0=1, 3+2+3=8
        // if (sd.name === 'Bar') times += 40 // TEST
        while (times > 0) {
          this.frs.push(sd);
          times--;
        }
      });
    },
    shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    run: function () {
      if (!this.locked) {
        const min = 8;
        const max = 28;
        const momentum = Math.floor(Math.random() * (max - min + 1) + min);
        this.momentum = momentum;
        this.audio.spin.play();
        this.animate();
      } else {
        this.locked = false;
        this.$emit("stopped", this.reelTileData[this.reelIndex], true);
      }
    },
    animate: function () {
      this.$el.classList.add("move");
    },
    animateEnd: function () {
      this.$el.classList.remove("move");
      this.reIndex();
      this.momentum = this.momentum - 1;
      if (this.momentum > 0) {
        setTimeout(this.animate, 10);
      } else {
        const reelTileData = this.reelTileData[this.reelIndex];
        this.$emit("stopped", reelTileData);
        if (reelTileData.name === "Bar") {
          this.audio.barWin.play();
        } else {
          this.audio.spinEnd.play();
        }
        this.audio.spin.pause();
        this.audio.spin.currentTime = 0.3;
      }
    },
    reIndex: function () {
      const end = this.reelTileData.length - 1;
      const index = this.reelIndex === 0 ? end : this.reelIndex - 1;
      // const index = this.index === end ? 0 : this.index + 1
      this.reelIndex = index;
      this.tile1Index = index === 1 ? end : index === 0 ? end - 1 : index - 2;
      this.tile2Index = index === 0 ? end : index - 1;
      this.tile3Index = index;
      this.tile4Index = index === end ? 0 : index + 1;
      this.tile5Index = index === end - 1 ? 0 : index === end ? 1 : index + 2;
    },
    lock: function () {
      if (this.canlock) {
        this.locked = !this.locked;
        this.audio.lock.play();
      }
    },
  },
};
</script>
<style lang="postcss">
/* @use postcss-cssnext; */
:root {
  --tileSize: 90px;
}
.Reel {
  width: var(--tileSize);
  height: calc(var(--tileSize) * 2.333);
  overflow: hidden;
}
.Reel.is-locked {
  /*   opacity: 0.8; */
  background: rgba(0, 0, 0, 0.1);
}
.Reel:not(:last-child) {
  border-right: 1px solid rgba(128, 128, 128, 0.2);
}
.Reel-inner {
  position: relative;
  top: calc(var(--tileSize) * -1 * 1.333);
  display: flex;
  flex-direction: column;
}
.Reel.move .Reel-inner {
  transition: margin-top 0.04s linear;
  margin-top: var(--tileSize);
}
.Reel-image {
  width: var(--tileSize);
  /* width: var(--tileSize); */
  max-height: var(--tileSize);
}
</style>
